import React from 'react';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';

const CardAnimation = observer(() => {
  const { isStartCardImitation, selectedCardBackSideType } = cardsStore;

  return (
    <span
      className={`tb-card-imitation deck-1 ${selectedCardBackSideType} ${
        isStartCardImitation ? `start-anim` : ''
      }`}
    />
  );
});

export default CardAnimation;
